import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import Image, { ImageProps } from 'next/image';

const NextImage: FC<ImageProps> = ({ src, alt, className, ...rest }) => {
  return (
    <Image
      src={src}
      alt={alt}
      title={alt}
      sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 40vw'
      className={twMerge(`rounded-md`, className)}
      {...rest}
    />
  );
};

export default NextImage;
